module.exports = __webpack_public_path__ + "images/screen-shots/classroom-progress-bce0fb2ada5a442f9c6d603ae0f56cf2.png";